import { sumMoney } from "../checkout/money";
import { commonValue, slowestStatus } from "./orderStatus";

const VARIES = "Varies by supplier";

const byPosition = (a, b) => {
  const left = a.master?.position ?? Number.MAX_SAFE_INTEGER;
  const right = b.master?.position ?? Number.MAX_SAFE_INTEGER;

  return left - right;
};

const supplierRow = (item) => ({
  ...item.supplier,
  orderId: item.id,
  orderNumber: item.orderNumber,
  status: item.status,
});

const toSingleRow = (item) => ({
  key: `order:${item.id}`,
  isMaster: false,
  id: item.id,
  orderNumber: item.orderNumber,
  status: item.status,
  statusGroup: item.statusGroup,
  placedDate: item.placedDate,
  placedTime: item.placedTime,
  supplier: item.supplier,
  suppliers: [supplierRow(item)],
  deliveryTypeCode: item.deliveryTypeCode,
  deliveryTypeLabel: item.deliveryTypeLabel,
  deliveryLabel: item.deliveryLabel,
  scheduled: item.scheduled,
  paidAmount: item.paidAmount,
  subOrderCount: 1,
  loadedCount: 1,
  missingCount: 0,
});

const toMasterRow = (subOrders) => {
  const sorted = [...subOrders].sort(byPosition);
  const lead = sorted[0];
  const master = lead.master;

  return {
    key: `master:${master.id}`,
    isMaster: true,
    id: lead.id,
    orderNumber: master.orderNumber,
    status: slowestStatus(sorted.map((item) => item.status)),
    statusGroup: lead.statusGroup,
    placedDate: lead.placedDate,
    placedTime: lead.placedTime,
    supplier: lead.supplier,
    suppliers: sorted.map(supplierRow),
    deliveryTypeCode: commonValue(sorted.map((item) => item.deliveryTypeCode)),
    deliveryTypeLabel:
      commonValue(sorted.map((item) => item.deliveryTypeLabel)) || VARIES,
    deliveryLabel: commonValue(sorted.map((item) => item.deliveryLabel)) || VARIES,
    scheduled: sorted.some((item) => item.scheduled),
    paidAmount:
      master.paidAmount ||
      master.total ||
      sumMoney(sorted.map((item) => item.paidAmount)),
    subOrderCount: master.subOrderCount,
    loadedCount: sorted.length,
    missingCount: Math.max(0, master.subOrderCount - sorted.length),
  };
};

export const groupOrders = (items) => {
  const rows = [];
  const slotByMasterId = new Map();
  const subOrdersByMasterId = new Map();

  (items || []).filter(Boolean).forEach((item) => {
    const master = item.master?.subOrderCount > 1 ? item.master : null;

    if (!master) {
      rows.push(toSingleRow(item));
      return;
    }

    if (!slotByMasterId.has(master.id)) {
      slotByMasterId.set(master.id, rows.length);
      subOrdersByMasterId.set(master.id, [item]);
      rows.push(toMasterRow([item]));
      return;
    }

    const siblings = subOrdersByMasterId.get(master.id);
    siblings.push(item);

    rows[slotByMasterId.get(master.id)] = toMasterRow(siblings);
  });

  return rows;
};
